/** Placeholder shaped like the thing that is loading, instead of the word "Loading". */
export function Skeleton({ count = 6, ratio = '2:3' }: { count?: number; ratio?: '2:3' | '4:5' }) {
  return (
    <div className="opt-grid" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className={`skeleton skeleton--${ratio === '2:3' ? '23' : '45'}`}
          style={{ animationDelay: `${i * 70}ms` }}
        />
      ))}
    </div>
  );
}
